<template>
    <div>
        <HomeHero />

        <HomeSpecialtyHighlights :specialty_data="specialties_highlight" />

        <!-- <HomeDoctors :recommended_doctors="searchResults" /> -->
        <!-- {{ specialties }} -->
        <HomeBlogNew />
    </div>
</template>

<script setup>
// Enhanced SEO for home page
const { setSEOMeta, setOrganizationStructuredData, setLLMOptimizedMeta, setHreflangAlternates } = useSEO()

// Enable page transitions
definePageMeta({
  pageTransition: {
    name: 'page',
    mode: 'out-in'
  }
})

// Set comprehensive SEO for home page
setSEOMeta({
  title: '北美好医生 - 连接优质华人医疗资源',
  description: '北美领先的中文医疗服务平台，为华人患者提供便捷的医生预约、专科查找、医疗保险咨询等服务。找医生，就上北美好医生。',
  keywords: [
    '华人医生',
    '医生预约',
    '专科医生',
    '医疗保险',
    '纽约医生',
    '中文医疗服务',
    '北美医疗'
  ],
  ogImage: '/HYS-logo-icon-06.png',
  locale: 'zh-Hans'
})

// Emit hreflang alternates for all locales on homepage
try { setHreflangAlternates() } catch {}

// Set LLM-optimized metadata for home page
setLLMOptimizedMeta({
  contentType: 'service-page',
  primaryTopic: '华人医疗服务平台首页',
  keyTerms: [
    '华人医生',
    '医生预约',
    '专科医疗',
    '医疗保险',
    'HaoYiSheng'
  ],
  contentSummary: '北美好医生是专为华人提供医疗服务的平台，提供医生查找、预约挂号、专科信息等服务',
  targetAudience: '需要医疗服务的北美华人社区'
})

// Set organization structured data for home page
setOrganizationStructuredData({
  name: '北美好医生',
  alternateName: 'HaoYiSheng',
  description: '北美领先的中文医疗服务平台'
})

// Get search composable but handle SSR safely
let searchResults = ref([])
let specialties_highlight = ref([])

// Only run client-side operations after hydration
onMounted(async () => {
  try {
    // Initialize search on client side to avoid SSR issues
    const { searchQuery, searchResults: clientSearchResults, getSearchResults } = useSearch()
    searchResults = clientSearchResults
    
    // Get initial search results
    await getSearchResults("")
  } catch (error) {
    console.error("[Home Page] Error getting search results:", error)
  }
})

const target_specialties = ['Internal Medicine', 'Pediatrics', 'Podiatry', 'Physical Therapy', 'Pain Management', 'Otolaryngology', 'Dermatology', 'Allergy & Immunology']

// Handle specialty data with proper error handling for SSR
try {
  const { data: specialtyData } = await useAsyncData('home-specialties', async () => {
    try {
      const specialties = await $fetch('/api/specialty/getSpecialties')
      if (!Array.isArray(specialties)) {
        console.warn('[Home Page] Invalid specialties response, using fallback')
        return []
      }
      return specialties.filter((spec) => target_specialties.includes(spec?.en_name))
    } catch (error) {
      console.error('[Home Page] Failed to fetch specialties:', error)
      return [] // Return empty array as fallback
    }
  }, {
    default: () => [], // Provide default value for SSR
    server: true, // Enable server-side fetching
    lazy: false // Fetch immediately
  })
  
  specialties_highlight.value = specialtyData.value || []
} catch (error) {
  console.error('[Home Page] Failed to load specialty data:', error)
  specialties_highlight.value = []
}
</script>

